import React, {useState} from "react";
import { useDispatch, useSelector } from 'react-redux'
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { SetLogin }  from "../../slices/user/UserSlice";
import {subtractSeconds} from "../../functions/functions";
import {setError} from "../../slices/error/ErrorSlice";

export default function Home () {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authTime = useSelector(state => state.app.authTime);

    const[login, setLogin] = useState('');
    const[password, setPassword] = useState('');

    function handleSubmit(e) {
        e.preventDefault();
        console.log(login, password);
        const params = new URLSearchParams();
        params.append('_username', login);
        params.append('_password', password);

        axios.post('/api/login', params)
            // .then((response)=>{
            //     return axios.get('/api/user-info')
            // })
            .then(response => {
                if (response.status === 200) {
                    dispatch(SetLogin(response.data));
                    localStorage.setItem("endAuthTime", Date.parse(subtractSeconds(new Date(), authTime).toISOString()).toString());
                    navigate('/view')
                }
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            });
    }

    return (
        <>
            <h1>Вход в систему</h1>
            <div className='login-wrap'>
                <form>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Логин</label>
                        <input type="email" className="form-control" id="exampleInputEmail1"
                               onChange={(e) => {
                                   setLogin(e.target.value)
                               }}
                               aria-describedby="emailHelp"/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputPassword1" className="form-label">Пароль</label>
                        <input type="password" className="form-control" id="exampleInputPassword1"
                               onChange={(e) => {
                                   setPassword(e.target.value)
                               }}/>
                    </div>
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Войти</button>
                </form>
            </div>
        </>
    )
}